import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import "./Table.css";
import { getDesignOptionsClasses } from "./utils";
import utils from "../../services/utils";

const ResponsiveTable = ({ data, columns, designOptions, actionBtns, btns,filterColumnNames  }) => {
    // Filter out the specific column
    const filteredColumns = columns.filter(c => !filterColumnNames.includes(c.text.trim()));
    const filteredColumnIds = filteredColumns.map(c => c.id);
    const [isMobile, setIsMobile] = useState(window.matchMedia("(max-width: 600px)").matches);
    // Filter rows data based on the filtered columns
    const rows = data.map(d => filteredColumnIds.map(c => d[c]));

    const Tr = ({ row, idx }) => {
        const [isOpened, setIsOpened] = useState(false);
        const rowId = row[0]; // Assuming the first column contains the ID, adjust if necessary

        return (
            <tr className={isOpened ? 'open' : ''} onClick={() => setIsOpened(!isOpened)}>
                {row.map((value, idx) => (
                    <td key={`responsive-table-value-${idx}`} {...(idx !== 0 || !isMobile ? { 'data-label': filteredColumnIds[idx] } : {})}>
                        {idx === 0 && isMobile ? <span>{row[2]}</span> : value}
                    </td>
                ))}
                <td data-label="Actions">
                    {buttonsCreats(row)}
                </td>
            </tr>
        );
    };

    const buttonsCreats = (row) => {
        const buttons = [];
        btns.forEach((btn, index) => {
            buttons.push(
                <button key={index} onClick={() => handleButtonClick(row[0], btn.action)}>
                    {utils.useLang(btn.name)}
                </button>
            );
        });
        return buttons;
    };

    const handleButtonClick = (rowValue, action) => {
        actionBtns(rowValue, action);
    };

    const designOptionsClasses = useMemo(() => getDesignOptionsClasses(designOptions), [designOptions]);

    // Update color design option
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.matchMedia("(max-width: 600px)").matches);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (!designOptions?.color) {
            return;
        }
        document.documentElement.style.setProperty('--custom-color-table', designOptions?.color);
    }, [designOptions?.color]);

    return (
        <table className={`rtr-table ${designOptionsClasses}`} cellPadding="0" cellSpacing="0" border={0} bgcolor="#eeeeee" align="left" width="100%">
            <thead>
            <tr>
                {filteredColumns.map((col, idx) => (
                    <th key={idx} data-label={col.text}>{col.text}</th>
                ))}
                <th key={'00000'}>{utils.useLang('ACTIONS')}</th>
            </tr>
            </thead>
            <tbody>
            {rows.map((row, idx) => {
                if (row.filter(Boolean).length === 0) {
                    return null;
                }
                return <Tr key={`responsive-table-tr-${idx}`} row={row} idx={idx} />;
            })}
            </tbody>
        </table>
    );
};

export { ResponsiveTable };
